import React, { useState } from 'react';

import {
  trackDemoResetConfirm,
  trackDemoResetCancel,
} from '../../../analytics';

import { Button, Modal } from '../../../components/general';

import useDemoData from '../../../hooks/useDemoData';

import { deleteFace } from '../../../services/api/faces';
import { fileDelete } from '../../../services/api/files';
import { queuesDelete } from '../../../services/api/queues';

interface Props {
  show: boolean;
  onHide: () => void;
}

const RestartDemoModal: React.FC<Props> = (props) => {
  const { show, onHide } = props;

  const { demoData, resetDemoData } = useDemoData();

  const [isProcessing, setIsProcessing] = useState(false);

  const handleRestart = async () => {
    setIsProcessing(true);

    // delete person
    await deleteFace(demoData.user.elementId, true);

    // delete photos
    await Promise.all(
      demoData.photos.map(async (id) => await fileDelete(id, true)),
    );

    // delete clips
    await Promise.all(
      demoData.clips.map(async (id) => {
        await queuesDelete(id, true);
        await fileDelete(id, true);
      }),
    );

    trackDemoResetConfirm();

    resetDemoData();
    setIsProcessing(false);
    onHide();
    window.location.reload();
  };

  return (
    <Modal show={show} onHide={() => !isProcessing && onHide()}>
      <Modal.Body centered>
        <h4>Restart the demo?</h4>

        <div>
          This will clear your current demo and start over. For a fresh result,
          we'd recommend using a different email so your new demo doesn't reuse
          these files.
        </div>

        <div className="w-full flex flex-col sm:flex-row gap-4">
          <Button
            onClick={handleRestart}
            className="w-full sm:w-1/2"
            isSubmitBtn
            isProcessing={isProcessing}
          >
            Yes, Restart Demo
          </Button>

          <Button
            onClick={() => {
              trackDemoResetCancel();
              onHide();
            }}
            colour="pink"
            className="w-full sm:w-1/2"
            disabled={isProcessing}
          >
            No, Cancel
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RestartDemoModal;
